import tokenImageN from "../assets/img/Token_no.webp";

const TokenImageNAUN: React.FC = () => {
  const handleClick = () => {
    window.open(
      "https://basescan.org/token/0x885f14Ec5c427767A660174ea0EA8C9953f3549D",
      "_blank"
    );
  };

  return (
    <img
      src={tokenImageN}
      alt="NAUN Token"
      onClick={handleClick}
      className="w-10 h-10 sm:w-12 sm:h-12 cursor-pointer rounded-full shadow-md hover:shadow-xl hover:scale-105 transition duration-300 ease-in-out"
    />
  );
};

export default TokenImageNAUN;
